export default __webpack_public_path__ + "static/media/grey-streak-tree.4b49601f.svg";